import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/max-production-model", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/max-production-model/csv", params);
};

const get = id => {
  return restApi.get(`/api/max-production-model/${id}`);
};

const upsert = data => {
  return restApi.post("/api/max-production-model/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/max-production-model/${ids}`);
};

const maxProductionModelService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default maxProductionModelService;
